/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AffiliatedProfiles } from '../models/affiliated-profiles';
import { listAffiliatedProfilesInGroupForProfile } from '../fn/profile-affiliated/list-affiliated-profiles-in-group-for-profile';
import { ListAffiliatedProfilesInGroupForProfile$Params } from '../fn/profile-affiliated/list-affiliated-profiles-in-group-for-profile';

@Injectable({ providedIn: 'root' })
export class ProfileAffiliatedService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listAffiliatedProfilesInGroupForProfile()` */
  static readonly ListAffiliatedProfilesInGroupForProfilePath = '/rest/profile/{id}/affiliated';

  /**
   * List all awards given to profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAffiliatedProfilesInGroupForProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAffiliatedProfilesInGroupForProfile$Response(params: ListAffiliatedProfilesInGroupForProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<AffiliatedProfiles>> {
    return listAffiliatedProfilesInGroupForProfile(this.http, this.rootUrl, params, context);
  }

  /**
   * List all awards given to profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAffiliatedProfilesInGroupForProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAffiliatedProfilesInGroupForProfile(params: ListAffiliatedProfilesInGroupForProfile$Params, context?: HttpContext): Observable<AffiliatedProfiles> {
    return this.listAffiliatedProfilesInGroupForProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<AffiliatedProfiles>): AffiliatedProfiles => r.body)
    );
  }

}
